export enum WhiteLabels {
  CivPay = 'CivPay',
}
